module.exports = __webpack_public_path__ + "static/media/agent6.81ded311.png";